import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteOwner } from '../Api'

export default generateApiAction({
  baseType: Types.OWNERS.DELETE,
  api: deleteOwner,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/owners/DeleteAction.js